if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';

      // Set-up event listener to listen for change event in <variant-radios>
      const variantRadios = document.getElementById(`VariantRadios-${this.dataset.sectionId}`)
      if(variantRadios) {
        this.currentVariant = variantRadios.getCurrentVariant();
        variantRadios.addEventListener('variantChange', this.onVariantChange.bind(this))
      }

      // Pull in parent product data
      this.getProductData();
      // Fire GA4 view_item when the variant being displayed on the PDP changes
      this.ga4_view_item();
    }

    /**
     * Pulls variants data for this product from a script tag that must be nested inside of the web component.
     * @returns {Object} Shopifys product.variants object for this product
     * @see https://shopify.dev/api/liquid/objects/product#product-variants
     */
      getProductData() {
      const jsonProductData = this.querySelector('#json-product[type="application/json"]');
      if(!this.productData && jsonProductData !== null) {
        this.productData = JSON.parse(jsonProductData.textContent).product;
        this.currencyCode = JSON.parse(jsonProductData.textContent).currency;
        // Remove the <script> tag we used to load the JSON from the DOM
        jsonProductData.parentNode.removeChild(jsonProductData);
      }
      return Array.isArray(this.productData) ? this.productData : [];
    }

      /**
     * GA4 DataLayer Event: View Item
     * @see https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtm#view_item
     */
    ga4_view_item() {
      try {
        const { id: item_id, title: item_name, tags, type: item_category } = this.productData;
        let item_variant = '';

        if (this.currentVariant) {
          item_variant = this.currentVariant.id;
        }

        const item = {
          item_id,
          item_name,
          item_variant,
          item_category,
          quantity: 1,
          ...calculatePrice({
            product: this.currentVariant ? this.currentVariant : this.productData,
            product_tags: Array.isArray(tags) ? tags : []
          })
        };
        pushDataLayerEvent({
          event: 'view_item',
          ecommerce: {
            currency: this.currencyCode,
            value: calculateValue([item]),
            items: [item]
          }
        });
      } catch (error) {
        console.log('GA4: view_item', error);
      }
    }

    onVariantChange(e) {
      // Add to Cart Enabled
      if(e.detail.available === true) {
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.disabled = false;
        this.submitButton.querySelector('#cart-text-content').textContent = window?.variantStrings?.addToCart || 'Add to Cart';
        this.submitButton.classList.remove('visually-hidden');

        // If user lands on PDP with placeholder data, then selects valid variant, remove alert & set quantity input value
        const alertElement = document.querySelector('.placeholder-data-alert');
        if (alertElement) {
          location.reload();
        }

      // Add to Cart Disabled
      } else {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.disabled = true;
        this.submitButton.querySelector('#cart-text-content').textContent = window?.variantStrings?.soldOut || 'Sold Out';
        if(this.hasKlaviyoBis === true && this.klaviyoBis() !== null) {
          this.submitButton.classList.add('visually-hidden');
        }
      }
      // Fire GA4 view_item when the variant being displayed on the PDP changes
      this.ga4_view_item();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay-spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

           // Fetch the quantity from the QuantityInput element
           const quantityInput = document.querySelector('.product quantity-input');
           let quantity = parseInt(quantityInput.querySelector('input.quantity-input').value);

           /**
            * GA4 DataLayer Event: Add To Cart
            * @see https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtm#add_to_cart
            */
            try {
              const { id: item_id, title: item_name, tags, type: item_category } = this.productData;
              let item_variant = '';

              if (this.currentVariant) {
                item_variant = this.currentVariant.id;
              }

              const item = {
                item_id,
                item_name,
                item_variant,
                item_category,
                quantity: quantity,
                ...calculatePrice({
                  product: this.currentVariant ? this.currentVariant : this.productData,
                  product_tags: Array.isArray(tags) ? tags : []
                })
              };
              pushDataLayerEvent({
                event: 'add_to_cart',
                ecommerce: {
                  currency: this.currencyCode,
                  value: calculateValue([item]),
                  items: [item]
                }
              });
            } catch (error) {
              console.log('GA4: add_to_cart', error);
            }

          this.error = false;
          this.cart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay-spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form-error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form-error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
